export default __webpack_public_path__ + "static/media/INACTIVE-3.14332e01.png";